var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.852,
    height: 23.425,
    viewBox: "0 0 24.852 23.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_18078",
    "data-name": "Path 18078",
    d: "M2.3,7.884,13.792,1.336a1.3,1.3,0,0,1,1.279,0L26.55,7.885a.585.585,0,0,1,.3.507V23.411a1.213,1.213,0,0,1-1.243,1.181H3.243A1.213,1.213,0,0,1,2,23.411V8.391a.585.585,0,0,1,.3-.507ZM4.485,9.395V22.23H24.367V9.394l-9.936-5.67L4.485,9.394ZM14.5,15.968,21.082,10.7l1.6,1.807-8.164,6.54L6.18,12.512l1.581-1.824,6.74,5.28Z",
    transform: "translate(-2 -1.167)",
    fill: "#595778",
    opacity: 0.66
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginMail);
export default __webpack_public_path__ + "static/media/loginMail.fca10f561e826879d3a2d28a0f10257b.svg";
export { ForwardRef as ReactComponent };